import React from 'react';
import FileBlock from './FileBlock';
import styles from '../styles.module.scss';

export function UploadedFilesSet({files = [], ...props}) {
  const mapFiles = file => <FileBlock {...file} {...props}/>;
  const sameFolderFiles = files.filter(item => item.folderID === props.folderID);
  const differentFolderFiles = files
    .filter(item => item.folderID !== props.folderID)
    .sort((a, b) => a.folderID - b.folderID);
  const result = [...sameFolderFiles, ...differentFolderFiles];
  return <div className={styles.container}>{result.map(mapFiles)}</div>;
}